import {
  INVALID_FILENAME_CHARACTERS_REGEX,
  WINDOWS_RESERVED_FILENAME_REGEX,
} from "constants/regex";

export const sanitizeFilename = (
  filename: string,
  fallbackFilename: string,
): string => {
  const withoutControlCharacters = Array.from(filename)
    .filter((character) => {
      const code = character.codePointAt(0);

      return code !== undefined && code >= 32;
    })
    .join("");

  const sanitized = withoutControlCharacters
    .replace(INVALID_FILENAME_CHARACTERS_REGEX, "_")
    .replaceAll(/[\s.]+$/g, "")
    .trim();

  if (!sanitized || sanitized === "." || sanitized === "..") {
    return fallbackFilename;
  }

  if (WINDOWS_RESERVED_FILENAME_REGEX.test(sanitized)) {
    return fallbackFilename;
  }

  return sanitized;
};
